import React, { useEffect, useState } from 'react';
import { LuExternalLink } from "react-icons/lu";
import Popup from '../../Shared/Popup';
import CatalogueCard from '../CatalogueCard';
import Features from './Features';
import Screenshots from './Screenshots';

import { usePresignedUrl } from '../../../context/PresignedUrlContext';
import Loader from '../../Shared/Loader';

const CatalogueDetails = ({
    showPopup, handleClose,
    productsAndServicesFullData, productServiceDetails }) => {

    const {
        name, summary, description, teamContact,
        link, documentLink, techTag,
        features, screenshots
    } = productServiceDetails

    const { getPresignedUrl } = usePresignedUrl();
    const [imageUrl, setImageUrl] = useState('');
    const [imageLoading, setImageLoading] = useState(false);
    const [similarProductAndService, setSimilarProductAndService] = useState([]);

    const fetchImage = async (imageKey) => {
        try {
            const url = await getPresignedUrl(imageKey);
            setImageUrl(url);
        } catch (error) {
            console.error('Failed to load image', error);
        } finally {
            setImageLoading(false)
        }
    };

    const normalizeTag = tag => tag.toLowerCase().replace(/\s|[-]/g, '');

    const findSimilarByTechTags = () => {
        let jsonData = [];
        try {
            if (typeof productsAndServicesFullData === 'string') {
                jsonData = productsAndServicesFullData;
            } else {
                jsonData = productsAndServicesFullData;
            }
        } catch (error) {
            console.error('Failed to parse JSON:', error);
            setSimilarProductAndService([]);
            return;
        }

        const normalizedTargetTags = productServiceDetails.techTag?.map(normalizeTag) || [];

        let result = jsonData?.filter(obj => {
            if (obj.id === productServiceDetails.id) return false;

            const objTags = obj.techTag?.map(normalizeTag) || [];
            return objTags.some(tag => normalizedTargetTags.includes(tag));
        });

        // If no techTag match found, fallback to team match
        if (result.length === 0 && productServiceDetails.team) {
            result = jsonData.filter(obj => {
                return obj.id !== productServiceDetails.id && obj.team === productServiceDetails.team;
            });
        }
        setSimilarProductAndService(result);
    };

    useEffect(() => {
        if (productServiceDetails && screenshots?.length > 0) {
            if (screenshots[0].imageURL !== '') {
                const imageKey = `Product_Catalogue/ScreenShotsImages${screenshots && screenshots?.length > 0 ? screenshots[0].imageURL : ''}`;
                setImageLoading(true)
                fetchImage(imageKey);
            } else {
                setImageUrl('');
            }
            findSimilarByTechTags()
        }
    }, [productServiceDetails]);

    return (
        <>
            <Popup
                show={showPopup}
                handleClose={handleClose}
                popupTitle={name}
                popupClass="catalogue-details-popup"
                popupSize="xl"
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-10 mx-auto">
                            <div className="text-center">
                                <h1 className="fw-bold text-center my-5">{summary}</h1>
                                <div className="d-flex">
                                    <a
                                        href={link === '' ? documentLink : link}
                                        target="_blank" rel="noreferrer"
                                        className="btn btn-primary btn-lg fw-bold flex-center mx-auto px-4"
                                    >
                                        Go to {link === '' ? 'Service Document' : 'Product Website'}
                                        <LuExternalLink className="ms-2" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {imageLoading ? <Loader /> : (imageUrl === '' || imageUrl === undefined ? ''
                    : <Screenshots imageUrl={imageUrl} />)
                }
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-10 mx-auto">
                            {features?.map((feature, index) => (
                                <Features key={index} featureTitle={feature.title} description={feature.description} featureClass={index % 2 !== 0 ? 'flex-row-reverse' : ''} />
                            ))}
                            <div className="row align-items-center mt-5">
                                <div className="col-md-12">
                                    <h2 className='text-center mb-3'>Similar Products & Services</h2>
                                </div>
                                <p className="text-center mb-3">The Public Cloud Shared Services (PCSS) team is dedicated to delivering innovative, secure, and scalable cloud solutions. We streamline operations and enable organizations to thrive in a cloud-first world.</p>
                                <div className="row ">
                                    {
                                        similarProductAndService.slice(0, 3)?.map((product, index) => (
                                            <div className="col-md-4" key={index}>
                                                <CatalogueCard
                                                    type={product.type}
                                                    name={product.name}
                                                    description='Please go to details page for more details'
                                                />
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            <div className="row mt-5">
                                <div className="col-md-6">
                                    <h4 className="fw-bold">Tech Stacks</h4>
                                    <ul className="text-muted">
                                        {techTag?.map((tech, index) => (
                                            <li key={index}>{tech}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="row my-5">
                                <div className="col-md-6">
                                    <h4 className="fw-bold">Contact</h4>
                                    <p className="text-muted">
                                        {teamContact}
                                    </p>
                                </div>
                                <div className="col-md-6">
                                    <h4 className="fw-bold">Support</h4>
                                    <p className="text-muted">
                                        {teamContact}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            </Popup >
        </>
    );
};

export default CatalogueDetails;